import {
  Box,
  Checkbox,
  FormControlLabel,
  Typography
} from "@mui/material";

type PublicationCardProps = {
  title: string;
  data: any[];
  subscribePublication: Function;
  type: any;
  unsubscribePublication: Function;
};
const PublicationCard = ({
  title,
  data,
  type,
  subscribePublication,
  unsubscribePublication,
}: PublicationCardProps) => {
  return (
    // <Card
    //   sx={{
    //     display: "flex",
    //     position: "relative",
    //     boxShadow: 3,
    //     flex: 1,
    //     minWidth: 250,
    //   }}
    // >
    //   <CardContent
    //     sx={{
    //       display: "flex",
    //       flexDirection: "column",
    //       position: "relative",
    //       height: "auto",
    //       maxHeight: "100%",
    //       overflow: "hidden",
    //       pb:"16px !important"
    //     }}
    //   >
    //     <Typography variant="subtitle1">
    //       <strong>{title}</strong>
    //     </Typography>
    //     <FormControl
    //       sx={{
    //         height: "auto",
    //         display: "flex",
    //         minHeight: 0,
    //         overflow: "auto",
    //       }}
    //     >
    //       {data.map((item, index) => (
    //         <FormControlLabel
    //           key={index}
    //           control={
    //             <Checkbox
    //               onChange={(event) => {
    //                 if (event.target.checked === true) {
    //                   // subscribe
    //                   subscribePublication({
    //                     publicationId: item.publicationId,
    //                     type: type,
    //                     id: item.id,
    //                   });
    //                 } else if (event.target.checked === false) {
    //                   // unsubscribe
    //                   unsubscribePublication({
    //                     id: item.id,
    //                     publicationId: item.publicationId,
    //                     type: type,
    //                   });
    //                 }
    //               }}
    //               checked={item.publicationId != null}
    //             />
    //           }
    //           label={<Typography>{item.name}</Typography>}
    //         />
    //       ))}
    //     </FormControl>
    //   </CardContent>
    // </Card>
    <Box
      display={"flex"}
      gap={1}
      boxShadow={3}
      justifyContent={"flex-start"}
      alignContent={"flex-start"}
      p={1}
      overflow={"auto"}
      width={"100%"}
      borderRadius={2}
      flexWrap={"wrap"}
      flexDirection={"column"}
    >
      {data.length>0 ?data
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((item, index) => (
          <Box key={index}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(event) => {
                    if (event.target.checked === true) {
                      // subscribe
                      subscribePublication({
                        publicationId: item.publicationId,
                        type: type,
                        id: item.id,
                      });
                    } else if (event.target.checked === false) {
                      // unsubscribe
                      unsubscribePublication({
                        id: item.id,
                        publicationId: item.publicationId,
                        type: type,
                      });
                    }
                  }}
                  checked={item.publicationId != null}
                />
              }
              label={<Typography>{item.name}</Typography>}
            />
          </Box>
        )) : <Typography>No <strong>{title}</strong> to publish/unpublish!</Typography>}
    </Box>
  );
};

export default PublicationCard;
